import React, { useState, useRef, useEffect } from 'react';

const Filters = ({ categories, sectors, authors, years, onFilterChange, category, author, search, sector, year }) => {
    const [rawSearch, setRawSearch] = useState(search);
    const debounceTimeout = useRef(null);

    useEffect(() => {
        setRawSearch(search); // Sync external prop to local state
    }, [search]);

    const handleFilterChange = (event) => {
        const { name, value } = event.target;

        if (name === 'blog-filters__search') {
            setRawSearch(value);

            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }

            debounceTimeout.current = setTimeout(() => {
                onFilterChange(name, value);
            }, 500); // debounce delay
        } else {
            onFilterChange(name, value);
        }
    };

    return (
        <div className="blog-filter">
            <div id="blog-filters-search" className="search-bar">
                <input
                    aria-labelledby="blog-filters-search"
                    className="form-control search-blog"
                    name="blog-filters__search"
                    onChange={handleFilterChange}
                    type="text"
                    placeholder="Search by title"
                    value={rawSearch}
                />
            </div>

            <div id="blog-filters-category" className="category-field">
                <select
                    aria-labelledby="blog-filters-category"
                    className="form-select"
                    name="blog-filters__category"
                    onChange={handleFilterChange}
                    value={category}
                >
                    <option value="">Category</option>
                    {categories.map((category) => (
                        <option key={category.id} value={category.id}>{category.name}</option>
                    ))}
                </select>
            </div>

            <div id="blog-filters-sector" className="category-field">
                <select
                    className="form-select"
                    name="blog-filters__sector"
                    onChange={handleFilterChange}
                    value={sector}
                >
                    <option value="">Sector</option>
                    {sectors.map((sector) => (
                        <option key={sector.id} value={sector.id}>{sector.name}</option>
                    ))}
                </select>
            </div>

            <div id="blog-filters-year" className="category-field">
                <select
                    aria-labelledby="blog-filters-year"
                    className="form-select"
                    name="blog-filters__year"
                    onChange={handleFilterChange}
                    value={year}
                >
                    <option value="">Year</option>
                    {years.map((year) => (
                        <option key={year} value={year}>{year}</option>
                    ))}
                </select>
            </div>

            <div id="blog-filters-author" className="category-field">
                <select
                    aria-labelledby="blog-filters-author"
                    className="form-select"
                    name="blog-filters__author"
                    onChange={handleFilterChange}
                    value={author}
                >
                    <option value="">Author</option>
                    {authors.map((author) => (
                        <option key={author.id} value={author.id}>{author.name}</option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default Filters;
